/**
 * Zweck: Beschreibt die TypeScript-Bausteine für den Frontend-Bereich frontend/src/app/models/subbestellung.ts.
 */
import {BestellungPreisUndMwstSatz} from './bestellung-preis-und-mwst-satz';
import {BestellungEntry} from './bestellung-entry';

/**
 * Zweck: Beschreibt class Subbestellung und ihren Daten- oder Funktionsvertrag.
 */
export class Subbestellung {
  knd_nr: string;
  artikelstamm: string;
  summen: BestellungPreisUndMwstSatz[];
  positionen: BestellungEntry[];

/**
 * Beschreibt Methode hatProbleme und ihren Rückgabevertrag.
 */
  hatProbleme() {
    let hatProbleme = false;
    this.positionen.some(p => {
      if (p.hatProbleme()) {
        hatProbleme = true;
        return true;
      } else {
        return false;
      }
    });

    return hatProbleme;
  }
}
